import { render, staticRenderFns } from "./FrameComment.vue?vue&type=template&id=130a96eb&scoped=true"
import script from "./FrameComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrameComment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FrameComment.vue?vue&type=style&index=0&id=130a96eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a96eb",
  null
  
)

export default component.exports